export default __webpack_public_path__ + "static/transforming-chaos-mnc-blockchain-7215549625237cadc3ea70b3a8f9edc8.png";